import { render, staticRenderFns } from "./sabreaktarim.vue?vue&type=template&id=79c71791&"
import script from "./sabreaktarim.vue?vue&type=script&lang=js&"
export * from "./sabreaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports